import React from 'react'
import { ModalEditLayoutFields, FormikSetFieldValue } from '../../../../../types/types'
import SwitchCheckbox from '../../../../../Components/UI/SwitchCheckbox/SwitchCheckbox'

type OrientationFieldProps = {
    value: ModalEditLayoutFields['adaptation']
    setFieldValue: FormikSetFieldValue<ModalEditLayoutFields>
}

const OrientationField: React.FC<OrientationFieldProps> = React.memo(({ value, setFieldValue }) => {

    const handleChange = (value: boolean) => {
        setFieldValue('adaptation', value)
    }

    return (
        <SwitchCheckbox
            text="Необходимость адаптации"
            checked={value}
            classes={['bf-create-adaptive', 'bf-edit-layout__adaptive']}
            onChange={e => handleChange(e?.target.checked || false)}
        />
    )
})

export default OrientationField